import styled from "styled-components";

import { colors, shadows } from "shared/ui/tokens";

const TRACK_WIDTH = 44;
const TRACK_HEIGHT = 26;
const THUMB_SIZE = 20;
const THUMB_OFFSET = 3;

export const Row = styled.div<{ $disabled?: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

export const Track = styled.button<{ $checked: boolean }>`
    position: relative;
    flex: 0 0 auto;
    width: ${TRACK_WIDTH}px;
    height: ${TRACK_HEIGHT}px;
    margin-top: 1px;
    padding: 0;
    border: 0;
    border-radius: ${TRACK_HEIGHT / 2}px;
    background: ${({ $checked }) => ($checked ? colors.primary : colors.fieldBorder)};
    cursor: pointer;
    transition: background 0.18s ease;
    outline: none;

    &:disabled {
        cursor: default;
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px ${colors.infoBorder};
    }
`;

export const Thumb = styled.span<{ $checked: boolean }>`
    position: absolute;
    top: ${THUMB_OFFSET}px;
    left: ${THUMB_OFFSET}px;
    width: ${THUMB_SIZE}px;
    height: ${THUMB_SIZE}px;
    border-radius: 50%;
    background: ${colors.surface};
    box-shadow: ${shadows.switchThumb};
    transition: transform 0.18s ease;
    transform: translateX(
        ${({ $checked }) => ($checked ? TRACK_WIDTH - THUMB_SIZE - THUMB_OFFSET * 2 : 0)}px
    );
`;

export const Text = styled.span<{ $disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding-top: 2px;
    cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
`;

export const LabelText = styled.span`
    font-size: 0.9375rem;
    color: ${colors.textPrimary};
`;

export const Hint = styled.span`
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;
